import React from "react";
import OrderComplete from "../components/OrderComplete";

const Completed = () => {
  return <OrderComplete />;
};

export default Completed;
